export const SET_BOT_CHARGE = "billReducer/SET_BOT_CHARGE";

export const setBotcharge = (val)  => (disptch) => {
  return disptch({
    type: SET_BOT_CHARGE,
    payload: val,
  });
};